
import CategoryListItem from '@/components/CategoryListItem'

export default {
  name: 'CategoryList',
  components: { CategoryListItem },
  props: { categories: Array },
}
